import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsNumberOrFloatValidator {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_number_value" />
  }

  validate() {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(this.value)) {
      return this.errorMessage
    }

    return null
  }
}
